import { gql } from "@apollo/client";
import Field from "controls/Field";
import FormDialog from "controls/FormDialog";
import FormText from "controls/FormText";
import { useActionFragment } from "hooks/useAction";
import useData from "hooks/useData";
import useIsAdmin from "hooks/useIsAdmin";
import SelectInput from "inputs/SelectInput";
import SwitchInput from "inputs/SwitchInput";
import { VideoSwitchOutline } from "mdi-material-ui";
import React from "react";

const QUEUE_OPTIONS = [
  ["Standard", "standard"],
  ["Canary", "canary"],
  ["On-demand", "ondemand"],
];

VideosReEncodeDialog.useButtonProps = ({ videoIds }) => {
  const isAdmin = useIsAdmin();
  const [data] = useData(
    gql`
      query VideosReEncodeDialogButtonProps($videoIds: [ID!]!) {
        videos(ids: $videoIds) {
          id
          originalVideoDeleted
        }
      }
    `,
    { videoIds },
  );

  return {
    icon: <VideoSwitchOutline />,
    hidden: !isAdmin || data?.videos.some((v) => v.originalVideoDeleted),
    content: "Re-encode",
  };
};

export default function VideosReEncodeDialog({ videoIds, onClose, onSubmit }) {
  const videosReEncode = useActionFragment("videosReEncode");

  return (
    <FormDialog
      header="Re-encode Video"
      onClose={onClose}
      onSubmit={async (formData) => {
        await videosReEncode({
          input: {
            videoIds,
            ...formData,
          },
        });
        await onSubmit?.();
      }}
    >
      <FormText uiStringKey="readmin.video.re_encode_dialog.description" />
      <Field
        name="queue"
        label="Queue"
        required
        defaultValue="standard"
        input={<SelectInput options={QUEUE_OPTIONS} />}
        helperTextUiStringKey="readmin.video.re_encode_dialog.fields.queue"
      />
      <Field
        name="debug"
        label="Debug"
        input={<SwitchInput />}
        helperTextUiStringKey="readmin.video.re_encode_dialog.fields.debug"
      />
    </FormDialog>
  );
}
